<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.appointmentSchedule.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (rows().length === 0) {
        <p class="empty-state" data-testid="appointment-schedule-empty">{{ 'reports.appointmentSchedule.empty' | translate }}</p>
      } @else {
        <table class="report-table" data-testid="appointment-schedule-table">
          <thead>
            <tr>
              <th>{{ 'reports.appointmentSchedule.start' | translate }}</th>
              <th>{{ 'reports.appointmentSchedule.type' | translate }}</th>
              <th>{{ 'reports.appointmentSchedule.status' | translate }}</th>
              <th>{{ 'reports.appointmentSchedule.assignee' | translate }}</th>
              <th>{{ 'reports.appointmentSchedule.contact' | translate }}</th>
              <th>{{ 'reports.appointmentSchedule.address' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.appointmentId) {
              <tr [attr.data-testid]="'appointment-row-' + row.appointmentId">
                <td>{{ row.scheduledStart | dateTimezone }}</td>
                <td>{{ row.appointmentType }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.assigneeName }}</td>
                <td>{{ row.leadContactName }}</td>
                <td>{{ row.addressLabel }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </app-card-content>
    @if (canExport) {
      <app-card-actions class="no-print">
        <app-button variant="outlined" (click)="exportCsv()" data-testid="export-csv-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportCsv' | translate }}
        </app-button>
        <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-xlsx-button">
          <app-icon name="download" [size]="16" />
          {{ 'reports.exportXlsx' | translate }}
        </app-button>
      </app-card-actions>
    }
  </app-card>
</div>
